<template>
<!-- DEVGB -->
    <div class="size1 bg0 where1-parent">
        <div class="size3 flex-col-sb flex-w p-l-50 p-t-25 p-b-44 respon1 reponsive-celular">
            <center class="center-header-login">                
                <img src="@/assets/LOGO SEPLAG - AZUL (T) VAZADO.svg" class="icon-login">
            </center>
            <div class="p-b-10 p-t-5">
                <TabView :activeIndex="tabAtiva" @tab-change="onTabChange">
                    <TabPanel header="Emitir certidão">
                        <p class="m1-txt1 p-b-20" style="text-align:center">
                            Informe os dados para gerar a Certidão
                        </p>
                        <form class="p-grid p-fluid">
                            <div class="wrap-input100 m-b-10 validate-input"  data-validate="Tipo requerido">
                                <Dropdown v-model="registro.tipoCertidao" :change="validaTipoCertidao()" class="s2-txt1 placeholder0 input100" style="border: none" :options="listaTipoCertidao" optionLabel="name" optionValue="code" placeholder="Selecionar tipo de Certidão"/>
                                <span class="focus-input100"></span>
                            </div>
                            <div class="wrap-input100 m-b-10 m-t-10 validate-input" v-if="filtro.nome" data-validate="Nome requerido">
                                <span class="p-float-label s2-txt1 placeholder0 input100" style="height: 100%">
                                    <InputText type="text" id="nome" @keydown="(e) => changenome(e.target.value)" @keyup="(e) => changenome(e.target.value)" class="s2-txt1 placeholder0 input100" style="border: none;text-transform:uppercase" v-model="registro.nome"/>
                                    <label for="nome">Nome Completo</label>
                                </span>
                            </div>
                            <div class="wrap-input100 m-b-10 m-t-10 validate-input" v-if="filtro.cpf" data-validate="CPF requerido">
                                <span class="p-float-label s2-txt1 placeholder0 input100" style="height: 100%">
                                    <InputMask mask="999.999.999-99" id="cpf" class="s2-txt1 placeholder0 input100" style="border: none" @change="(e) => validarCPF(e.target.value)" v-model="registro.cpf"/>
                                    <label for="nome">CPF</label>
                                </span>
                                <span class="focus-input100"></span>
                            </div>
                            <div class="wrap-input100 m-b-10 m-t-10 validate-input" v-if="filtro.rg" data-validate="RG requerido">
                                <span class="p-float-label s2-txt1 placeholder0 input100" style="height: 100%">
                                    <InputText @keydown="(e) => changerg(e.target.value)" @keyup="(e) => changerg(e.target.value)" class="s2-txt1 placeholder0 input100" style="border: none" v-model="registro.rg" />
                                    <label for="nome">RG</label>
                                </span>
                                <span class="focus-input100"></span>
                            </div>
                            <div class="wrap-input100 m-b-10 m-t-10 validate-input" v-if="filtro.rgOrg" data-validate="RG requerido">
                                <span class="p-float-label s2-txt1 placeholder0 input100" style="height: 100%">
                                    <InputText type="text" @keydown="(e) => changergorg(e.target.value)" @keyup="(e) => changergorg(e.target.value)" id="rgOrg" class="s2-txt1 placeholder0 input100" style="border: none;text-transform:uppercase" v-model="registro.rgOrgao"/>
                                    <label for="nome">RG (Órgão Expedidor/ UF)</label>
                                </span>
                                <span class="focus-input100"></span>
                            </div>
                            <div class="m-b-10 m-t-10 validate-input" style="width: 100%;" v-if="filtro.termo">
                                <p>
                                    <Checkbox name="termo" :binary="true" v-model="registro.termo" /> 
                                    Declaro que li e aceito o  
                                    <Button label="Termo de Consentimento" class="p-button-text" style="width: max-content; padding: 0" @click="exibirTelaTermo = true" />  </p>
                            </div>
                            <div align="center" style="width: 100%;">
                                <vue-recaptcha sitekey="6LdZS2seAAAAAGiK_ZQhvkFWIAuB9w_llxrp3lX9" @verify="onVerify" @expired="onExpired" ref="recaptcha"></vue-recaptcha>
                            </div>
                            <br/>
                            <div class="w-full-sm p-col-12">
                                <button class="s2-txt2 size4 bg1 bor1 hov1 trans-04" type="button" @click="gerarCertidao()">
                                    Gerar Certidão
                                </button>
                            </div>
                        </form>
                    </TabPanel>
                    <TabPanel header="Validar informação de certidão emitida">
                        <p class="m1-txt1 p-b-36" style="text-align:center">
                            Informe os dados para validar a Certidão
                        </p>
                        <form ref="formRef" class="p-grid p-fluid" >
                            <div class="wrap-input100 m-b-10 validate-input" data-validate="Tipo requerido">
                                <Dropdown v-model="validacao.tipoCertidaoValidacao" class="s2-txt1 placeholder0" v-on:change="camposPericia($event)" style="border: none; padding-left: 0;" :options="listaTipoCertidaoValidacao" optionLabel="name" optionValue="code" placeholder="Selecionar tipo de Certidão"/>
                                <span class="focus-input100"></span>
                            </div>
                            <div class="wrap-input100 m-b-10 m-t-10 validate-input" data-validate="Nome requerido">
                                <span class="p-float-label s2-txt1 placeholder0 input100" style="height: 100%">
                                    <InputText type="text" id="numrValida" class="s2-txt1 placeholder0 input100" style="border: none" v-model="validacao.numrValida"/>
                                    <label for="nome">Número de Validação</label>
                                </span>
                            </div>
                            <div class="wrap-input100 m-b-10 m-t-10 validate-input validacao-documento" v-if="filtro.cpf" data-validate="CPF requerido">
                                <span class="p-float-label s2-txt1 placeholder0 input100" style="height: 100%">
                                    <InputMask v-if="!isLaudo" mask="999.999.999-99" id="cpf" class="s2-txt1 placeholder0 input100" style="border: none" v-model="validacao.cpfValida"/>
                                    <label v-if="!isLaudo" for="nome">CPF que consta no documento</label>
                                    <InputText v-if="isLaudo" type="number" id="numrLaudo" class="s2-txt1 placeholder0 input100" style="border: none" v-model="validacao.cpfValida"/>
                                    <label v-if="isLaudo">Número do Laudo do Documento</label>
                                </span>
                                <!-- <input class="s2-txt1 placeholder0 input100" type="number" id="cpf" name='cpf' v-model="registro.cpf" placeholder="CPF sem pontos" maxlength="11"  @change="getAnosBase()"> -->
                                <span class="focus-input100"></span>
                            </div>
                            <br/>
                            <div class="w-full-sm p-col-12">
                                <button class="s2-txt2 size4 bg1 bor1 hov1 trans-04" type="button" @click="validaCertidao()">
                                    Validar Certidão
                                </button>
                            </div>
                        </form>
                    </TabPanel>
                </TabView>
            </div>  
            <div  class="p-col-12">
                <img src="@/assets/apoio-sti.png" class="img-footer-phone">
            </div>
        </div>

        <div class="flex-c-m bg-img1 size2 where1 overlay1 where2 respon2 display" style="">
            
        </div>
        
        <Dialog :visible="display"  :closable="false"> 
            <ul style="margin-left:7px">
                    <li style="font-size:15px;font-weight: bold;color:black;margin-bottom: 15px;margin-left:10px">Prezado usuário(a) por gentileza procurar:</li>
                    <li style="font-size:15px;font-weight: bold;color:black;margin-bottom: 8px;margin-left:10px; margin-right:10px; text-align:justify">I- Servidor civil, à Unidade Setorial de Correição, à Comissão Permanente ou Processante do órgão ou entidade de lotação, à Corregedoria Geral da Polícia Judiciária Civil.</li>
                    <li style="font-size:15px;font-weight: bold;color:black;margin-bottom: 8px;margin-left:10px; margin-right:10px; text-align:justify">II- Servidor militar, à Seção de Justiça e Disciplina (SJD), à Divisão de Justiça e Disciplina (DJD) ou à Corregedoria Geral da Polícia Militar ou à Corregedoria Geral do Corpo de Bombeiros Militar.</li>
                    <li style="font-size:15px;font-weight: bold;color:black;margin-left:10px; margin-right:10px; text-align:justify">III- Demais interessados, à Controladoria Geral do Estado.</li>
            </ul>
            <template #footer>
                <Button label="Fechar" icon="pi pi-close" @click="closeDialog" :style="{width: '150px', marginLeft:'10px'}" />
            </template>
        </Dialog>

         <!-- MODAL Termo de Consentimento -->        
        <cadastro-rapido tituloTela="Termo de Consentimento" v-model="exibirTelaTermo" tamanhoTela="800" :visivelbotao='false' :visivelFechar='true' >
            <div class="p-col-12" style="padding: 0 1.5cm">
                <h5 style="font-weight: bold; text-align: center; margin-bottom: 20px" >
                    LEI GERAL DE PROTEÇÃO DE DADOS PESSOAIS – LGPD
                </h5>
                <!-- <img src="@/assets/modal_cedula_c.png" class="img-atencao"> -->
                <p style="text-indent: 1.5cm;text-align: justify">
                    Através do presente instrumento, autorizo que o GOVERNO DO ESTADO MATO
                    GROSSO aqui denominada como CONTROLADORA, em razão do contrato de
                    trabalho, disponha dos meus dados pessoais e dados pessoais sensíveis, de
                    acordo com os artigos 7° e 11 da Lei n° 13.709/2018, conforme disposto neste
                    termo:
                </p>
                <br>
                <h5>CLÁUSULA PRIMEIRA</h5>
                <br>
                <h5>Dados Pessoais</h5>
                <br>
                <p style="text-align: justify">
                    O Titular autoriza a realizar o tratamento, ou seja, a utilizar os seguintes dados
                    pessoais, para os fins que serão relacionados na cláusula segunda:
                </p>
                <br>
                <p>
                    – Nome completo
                    <br>
                    – Número da Carteira de Identidade (RG) e Órgão expedidor/UF;
                    <br>
                    – Número de inscrição CPF.
                </p>
                <br>
                <h5>CLÁUSULA SEGUNDA</h5>
                <br>
                <h5>Finalidade do Tratamento dos Dados</h5>
                <br>
                <p style="text-align: justify">
                    O Titular autoriza que a Controladora utilize os dados pessoais e dados pessoais
                    sensíveis listados nesta termo APENAS com a finalidade de extrair a certidão
                    disciplinar.
                </p>
                <br>
                <p style="text-align: justify">
                    Parágrafo Primeiro: Em caso de alteração na finalidade, que esteja em desacordo
                    com o consentimento original, será comunicado o Titular, que poderá revogar o
                    consentimento, conforme previsto na cláusula sexta.
                </p>
                <br>
                <h5>CLÁUSULA TERCEIRA</h5>
                <br>
                <h5>Compartilhamento de Dados</h5>
                <br>
                <p style="text-align: justify">
                    A Controladora fica autorizada a compartilhar os dados pessoais do Titular com
                    outros agentes de tratamento de dados ou órgão de controle, caso seja necessário
                    para as finalidades listadas neste instrumento, desde que, sejam respeitados os
                    princípios da boa-fé, finalidade, adequação, necessidade, livre acesso, qualidade
                    dos dados, transparência, segurança, prevenção, não discriminação e
                    responsabilização e prestação de contas.
                </p>
                <br>
                <p style="text-align: justify">
                    Parágrafo Primeiro: Caso seja necessário o compartilhamento de dados com
                    terceiros que não tenham sido relacionados nesse termo ou qualquer alteração
                    contratual posterior, será ajustado novo termo de consentimento para este fim (§
                    6° do artigo 8° e § 2° do artigo 9° da Lei n° 13.709/2018).
                </p>
                <br>
                <h5>CLÁUSULA QUARTA</h5>
                <br>
                <h5>Responsabilidade pela Segurança dos Dados</h5>
                <br>
                <p style="text-align: justify">
                    A Controladora se responsabiliza por manter medidas de segurança, técnicas e
                    administrativas suficientes a proteger os dados pessoais do Titular e à Autoridade
                    Nacional de Proteção de Dados (ANPD), comunicando ao Titular, caso ocorra
                    algum incidente de segurança que possa acarretar risco ou dano relevante,
                    conforme artigo 48 da Lei n° 13.709/2020.
                </p>
                <br>
                <h5>CLÁUSULA QUINTA</h5>
                <br>
                <h5>Término do Tratamento dos Dados</h5>
                <br>
                <p style="text-align: justify">
                    À Controladora, é permitido manter e utilizar os dados pessoais do Titular durante
                    todo o período contratualmente firmado para as finalidades relacionadas nesse
                    termo e ainda após o término da contratação para cumprimento de obrigação legal
                    ou impostas por órgãos de fiscalização, nos termos do artigo 16 da Lei n°
                    13.709/2018.
                </p>
                <br>
                <h5>CLÁUSULA SEXTA</h5>
                <br>
                <h5>Direito de Revogação do Consentimento</h5>
                <br>
                <p style="text-align: justify">
                    O Titular poderá revogar seu consentimento, a qualquer tempo, por e-mail ou por
                    carta escrita, conforme o artigo 8°, § 5°, da Lei n° 13.709/2020.
                </p>
                <br>
                <h5>CLÁUSULA SÉTIMA</h5>
                <br>
                <h5>Tempo de Permanência dos Dados Recolhidos</h5>
                <br>
                <p style="text-align: justify">
                    O titular fica ciente de que a Controladora deverá permanecer com os seus dados
                    pelo período mínimo de guarda de documentos trabalhistas, previdenciários, bem
                    como os relacionados à segurança e saúde no trabalho, mesmo após o
                    encerramento do vínculo empregatício.
                </p>
            </div>
        </cadastro-rapido>
        <CardExibirPDF v-if="pdfElement" v-model="exibirPDF" :nomeDocumento='nomeDocumentoPDF' :tituloTela="this.titulo" :position="'top'" :tamanhoTela="'55.em'"  :alturaTela="'55.em'" :pdfElement="pdfElement" />
    </div>    
</template>

<script>

import CadastroRapido from '@/template/CadRapidoSeplag.vue'
import CardExibirPDF from '@/template/CardExibirPDF.vue'
import { baseApiUrlCertidao, baseApiUrlCertidaoSicc, simNao } from '@/config/global'
import { VueRecaptcha } from 'vue-recaptcha';


export default {
    components: { CardExibirPDF,CadastroRapido, VueRecaptcha },
    modoEdicao: 'logar',    
    data: function(){
        return {
            tabAtiva: 0,
            autoclear: false,
            name: 'vinculo',
            errors: [],
            exibirPDF: false,
            pdfElement: null,
            exibeMsg:false,
            nomeDocumentoPDF: 'Vinculo Servidor',
            isLaudo: false,
            filtro: {
                nome: true,
                cpf: true,
                rg: true,
                rgOrg: true,
                termo: false,
            },
            validacao:{
                numrValida: '',
                cpfValida: '',
                tipoCertidaoValidacao: '',
            },
            registro: {
                nome:'',
                cpf: '',
                rg:'',
                rgOrgao:'',
                tipoCertidao: '',
                termo: false,
                cpfValido: false,
            },
            listaTipoCertidao: [
                // {name:'Certidão Negativa Disciplinar', code: 'negativaDisciplinar'},
                {name:'Certidão Negativa de Vínculo Funcional', code: 'vinculoFuncional'},
                {name:'Certidão de Vínculo Previdenciário', code: 'vinculoPrevidenciario'}
            ],
            listaTipoCertidaoValidacao: [
                {name:'Certidão Negativa de Vínculo Funcional', code: 'vinculoFuncional'},
                {name:'Certidão de Vínculo Previdenciário', code: 'vinculoPrevidenciario'},
                {name:'Certidão de Crédito Salarial',code:'creditoSalarial'},
                {name:'Laudo Perícia Médica',code:'periciaMedica'}
            ],
            simNao: simNao,
            exibirTelaTermo: false,
            recaptchaWork: false,
            display: false,
        }
    },
    created() {
        const params = new URLSearchParams(window.location.search);

        const tab = params.get('aba');
        const cpf = params.get('cpf');
        const idenCertidao = params.get('id');
        const codigo = params.get('codigo');

        if (tab === 'validacertidaosicc') {
            this.tabAtiva = 1;

            this.validacao.numrValida = codigo || '';
            this.validacao.cpfValida = cpf || '';
            this.validacao.idenCertidao = idenCertidao || null;

            this.validacao.tipoCertidaoValidacao = 'creditoSalarial'
        }
    },
    mounted(){
        if((process.env.VUE_APP_AMBIENTE == "PRODUCAO")){
            this.listaTipoCertidao = this.listaTipoCertidao.filter((({code}) => code != "negativaDisciplinar" ))
        }
    },
    methods: { 
        onTabChange(event) {
            this.tabAtiva = event.index;
        },
        validaTipoCertidao(){
            switch (this.registro.tipoCertidao) {
                case 'negativaDisciplinar':
                    this.filtro.nome = true;
                    this.filtro.rg = true;
                    this.filtro.rgOrg = true;
                    this.filtro.termo = true;
        

                    break;
                case 'vinculoFuncional':
                    this.filtro.nome = true;
                    this.filtro.rg = true;
                    this.filtro.rgOrg = true;
                    this.filtro.termo = false;
                    
                    
                    break;
                case 'vinculoPrevidenciario':
                    this.filtro.nome = true;
                    this.filtro.rg = false;
                    this.filtro.rgOrg = false;
                    this.filtro.termo = false;
                    break;
                    
            
                default:
                    break;
            }
        },
        onVerify() {
            this.recaptchaWork = true;
        },
        onExpired: function () {
            this.recaptchaWork = false;
        },          
        validarCPF(cpf, campo=null) {
           
            var retorno = true;
            cpf = cpf.replace(/[^\d]+/g,'');
            let add = 0;	
            let rev = 0;		
            if(cpf == '') return false;	
            // Elimina CPFs invalidos conhecidos	
            if (cpf.length != 11 || 
                cpf == "00000000000" || 
                cpf == "11111111111" || 
                cpf == "22222222222" || 
                cpf == "33333333333" || 
                cpf == "44444444444" || 
                cpf == "55555555555" || 
                cpf == "66666666666" || 
                cpf == "77777777777" || 
                cpf == "88888888888" || 
                cpf == "99999999999")
                    retorno = false;		
            // Valida 1o digito	
            for (let i=0; i < 9; i ++)		
                add += parseInt(cpf.charAt(i)) * (10 - i);	
                rev = 11 - (add % 11);	
                if (rev == 10 || rev == 11)		
                    rev = 0;	
                if (rev != parseInt(cpf.charAt(9)))		
                    retorno = false;		
            // Valida 2o digito	
            add = 0;	
            for (let i = 0; i < 10; i ++)		
                add += parseInt(cpf.charAt(i)) * (11 - i);	
            rev = 11 - (add % 11);	
            if (rev == 10 || rev == 11)	
                rev = 0;	
            if (rev != parseInt(cpf.charAt(10)))
                retorno = false;		

            if(!retorno){
                this.$toast.add({severity:'error', summary: 'O CPF '+this.mascaraCpf(cpf)+' é inválido', life: 10000})
                if(campo!=null){
                    if(campo == "cpfConjuge"){
                        this.registroConjuge.parentalidade.pessoaParentalidade.numrCpf = ''
                    } else if(campo=="cpfMae"){
                        this.dadosPessoa.pessoa.numrCpfMae = ''

                    } else if(campo=="cpfPai"){
                        this.dadosPessoa.pessoa.numrCpfPai = ''
                    }
                }
            }
            this.registro.cpfValido = true;
        },
        limparDados(){
            this.registro.nome="",
            this.registro.cpf ="",
            this.registro.rg="",
            this.registro.rgOrgao =""
            this.registro.termo = false
        },
        gerarCertidao() {
            let JsonVinculoFuncional ={
                "nome": this.registro.nome,
                "cpf": this.registro.cpf.replace(/[^\d]+/g,''),
                "rg": this.registro.rg,
                "orgaoRg": this.registro.rgOrgao,
                "tipoCertidaoEnum": "COMPLETA",
                "saida":"E"
            }

            let JsonNegativaDiscip ={
                "nome": this.registro.nome,
                "cpf": this.registro.cpf.replace(/[^\d]+/g,''),
                "rg": this.registro.rg,
                "orgaoRg": this.registro.rgOrgao,
            }

            let JsonVinculoPrevidenciario ={
                "nome": this.registro.nome,
                "cpf": this.registro.cpf.replace(/[^\d]+/g,''),
                "tipoCertidaoEnum": "RESUMIDA"
            }
            switch (this.registro.tipoCertidao) {
                case 'negativaDisciplinar':
                    if (!this.registro.nome) {
                        this.$toast.add({severity:'error', summary: 'Preencha o campo Nome Completo', life: 3000});
                    }
                    if (!this.registro.cpf) {
                        this.$toast.add({severity:'error', summary: 'Preencha o campo CPF', life: 3000});
                    }else if (this.registro.cpfValido == false) {
                        this.$toast.add({severity:'error', summary: 'O  número de CPF informado é inválido.', life: 3000});
                    }
                    if (!this.registro.rg) {
                        this.$toast.add({severity:'error', summary: 'Preencha o campo RG', life: 3000});
                    }
                    if (!this.registro.rgOrgao) {
                        this.$toast.add({severity:'error', summary: 'Preencha o campo Órgão Expedidor/UF do RG', life: 3000});
                    }
                    if (!this.registro.termo) {
                        this.$toast.add({severity:'error', summary: 'É necessário aceitar o termo de Consentimento', life: 3000});
                    }

                    if (this.registro.termo && this.registro.rgOrgao && this.registro.rg && this.registro.cpf && this.registro.nome && this.recaptchaWork) {
                        this.$http.post(`${baseApiUrlCertidao}/publicos/certidaodisciplinar/gerar`,JSON.stringify(JsonNegativaDiscip)).then(res => {
                            if (res.data.nomeArquivo == null){
                                this.display = true
                            }else{
                                this.pdfElement = res.data.dadosRelatorioBase64
                                this.nomeDocumentoPDF = res.data.nomeArquivo
                                this.exibirPDF = true
                            }    
                            this.titulo = ''
                        })
                    }
                    break;

                case 'vinculoFuncional':
                    if (!this.registro.nome) {
                        this.$toast.add({severity:'error', summary: 'Preencha o campo Nome Completo', life: 3000});
                    }
                    if (!this.registro.cpf) {
                        this.$toast.add({severity:'error', summary: 'Preencha o campo CPF', life: 3000});
                    }else if (this.registro.cpfValido == false) {
                        this.$toast.add({severity:'error', summary: 'O  número de CPF informado é inválido.', life: 3000});
                    }
                    if (!this.registro.rg) {
                        this.$toast.add({severity:'error', summary: 'Preencha o campo RG', life: 3000});
                    }
                    if (!this.registro.rgOrgao) {
                        this.$toast.add({severity:'error', summary: 'Preencha o campo RG do Órgão Expedidor/UF', life: 3000});
                    }
                    if (this.registro.rgOrgao && this.registro.rg && this.registro.nome && this.registro.cpf && this.recaptchaWork) {
                        this.$http.post(`${baseApiUrlCertidao}/publicos/certidaovinculo/gerar`,JSON.stringify(JsonVinculoFuncional)).then(res => {
                        this.pdfElement = res.data.dadosRelatorioBase64
                        this.nomeDocumentoPDF = res.data.nomeArquivo
                        this.exibirPDF = true
                        this.titulo = 'Certidão Negativa de Vínculo Funcional'
                    })
                    }
                    
                    break;
                    
                case 'vinculoPrevidenciario':
                    if (!this.registro.cpf) {
                        this.$toast.add({severity:'error', summary: 'Preencha o campo CPF', life: 3000});
                    }else if (this.registro.cpfValido == false) {
                        this.$toast.add({severity:'error', summary: 'O  número de CPF informado é inválido.', life: 3000});
                    }
                    if (this.registro.cpf && this.recaptchaWork) {
                        this.$http.post(`${baseApiUrlCertidao}/publicos/certidaoprevidenciaria/gerar`,JSON.stringify(JsonVinculoPrevidenciario)).then(res => {
                            this.pdfElement = res.data.dadosRelatorioBase64
                            this.nomeDocumentoPDF = res.data.nomeArquivo
                            this.exibirPDF = true
                            this.titulo = 'Certidão de Vínculo Previdenciário'
                        })
                    }
                    break;

                default:
                    this.$toast.add({severity:'error', summary: 'Selecione o Tipo de Certidão', life: 3000});
                    break;
            }
            
            if (!this.recaptchaWork) {
                this.$toast.add({severity:'error', summary: 'Por favor, tente novamente.', life: 3000});                
            }
            this.recaptchaWork  = false
            this.limparDados()
            window.grecaptcha.reset()

        },
        validaCertidao(){

            let JsonVinculoValidar ={
                "chave": this.validacao.numrValida,
                "cpf": this.validacao.cpfValida.replace(/[^\d]+/g,'')
            }
            let JsonCertidaoCreditoValidacao ={
                "hashValidacao": this.validacao.numrValida,
                "numrCpf": this.validacao.cpfValida.replace(/[^\d]+/g,''),
                "idenCertidao": this.validacao.idenCertidao
            }

            let JsonLaudoValidar ={
                "hashLaudo": this.validacao.numrValida,
                "numLaudo": this.validacao.cpfValida
            }

            const validacoes = [
                { erro: this.validacao.tipoCertidaoValidacao, mensagem: 'Informe o tipo da certidão.' },
                { erro: this.validacao.numrValida, mensagem: 'Informe o número de validação' },
                { erro: this.validacao.cpfValida, mensagem: 'Informe o CPF ou o Número do Laudo que consta no documento' }
            ];

            for (let validacao of validacoes) {
                if (!validacao.erro) {
                    this.$toast.add({severity:'error', summary: validacao.mensagem, life: 3000});
                    return false;
                }
            }

            if (this.validacao.tipoCertidaoValidacao == 'creditoSalarial'){
                //this.$http.post(`${baseApiUrlCertidao}/publicos/validarcertidao/sicc`,JSON.stringify(JsonCertidaoCreditoValidacao)).then(res => {
                this.$http.post(`${baseApiUrlCertidaoSicc}/publicos/validarautenticidadecert`,JSON.stringify(JsonCertidaoCreditoValidacao)).then(res => {
                            this.pdfElement = res.data.dadosRelatorioBase64
                            this.nomeDocumentoPDF = res.data.nomeArquivo
                            this.exibirPDF = true
                            this.titulo = 'Comprovante validação'
                            this.$toast.add({severity:'success', summary: 'Certidão validada com sucesso.', life: 3000});
                        })
                        .catch(error => {
                            const mensagemErro = error.response && error.response.data && error.response.data.message 
                                ? error.response.data.message 
                                : 'Não foi possível validar a certidão. Verifique os dados ou tente novamente mais tarde.';

                            this.$toast.add({ severity: 'error', summary: 'Erro na validação', detail: mensagemErro, life: 5000 });
                        });
            }
            else if (this.validacao.tipoCertidaoValidacao == 'periciaMedica'){
                this.$http.get(`${baseApiUrlCertidao}/publicos/autenticarlaudo?hashLaudo=${JsonLaudoValidar.hashLaudo}&numLaudo=${JsonLaudoValidar.numLaudo}`).then(res => {
                            this.pdfElement = res.data.dadosRelatorioBase64
                            this.nomeDocumentoPDF = res.data.nomeArquivo
                            this.exibirPDF = true
                            this.titulo = 'Comprovante validação'
                            this.$toast.add({severity:'success', summary: 'Laudo Médico validado com sucesso.', life: 3000});
                        })
            }
            else {
                this.$http.post(`${baseApiUrlCertidao}/publicos/validarcertidao`,JSON.stringify(JsonVinculoValidar)).then(res => {
                            this.pdfElement = res.data.dadosRelatorioBase64
                            this.nomeDocumentoPDF = res.data.nomeArquivo
                            this.exibirPDF = true
                            this.titulo = 'Comprovante validação'
                        })
            }
        },
        closeDialog(){
            this.display = false;
        },
        changerg(e){
            this.registro.rg = e.replaceAll(/[^0-9/\s]/g, '');
        },
        changergorg(e){
            this.registro.rgOrgao = e.replaceAll(/[^a-zA-Z/\s]/g, '');
        },
        changenome(e){
            this.registro.nome = e.replaceAll(/[^a-zA-Z-áàâãéèêíïóôõöúçñ/\s]/g, '');
        },
        camposPericia(e){
            if(e.value == 'periciaMedica'){
                this.isLaudo = true;
            } else{
                this.isLaudo = false;
            }
        },
    },
    watch: {
            // eslint-disable-next-line 
        isLaudo(valorAtual, valorSalvo) {
            if (valorAtual == true) {
                this.isLaudo = true;
            }
            else{
                this.isLaudo = false;
            }
        }
    }
}
</script>
<!-- público -->
<style scoped>
    .img-centro{
        text-align: center;
    }
    .img-atencao{
        width: 36vw;
    }
    .messages-error{
        background: #FFCDD2;
        border: solid #F44336;
        border-width: 0 0 0 6px;
        color: #B71C1C;
        padding: 1rem 1.5rem;
    }

    .messages-info{
        background: #B3E5FC;
        border: solid #03A9F4;
        border-width: 0 0 0 6px;
        color: #01579B;
        padding: 1rem 1.5rem;
    }

    .imagem-fundo {
        background: url("../../assets/img-direito.png") ;
        
        background-position: 0% 45%;
        background-repeat: round;
        background-size: auto;
        height: 100.8vh; 
        flex-grow: 1;       

    }

    .img-sti{
        margin-bottom:0; bottom:0; right:0; position:absolute; width:8%
    }

    .texto-sistema{
        font-size: 20px;
        color: #005494;
        font-weight: bold;
        padding:0;
        margin:0;
        
    }

    .logingridcontrol1{
        background-color: #005494;
        background: url("../../assets/layout/img-login-pessoas.jpg");
        background-size: 105%;
        height: 75%;
        min-height: 75%;
    }
    .logingridcontrol2 {
        min-height: 75%;
        height: 75%;
        background-color: #fff;
    }   

    .logingridcontrol2 .border{
        border: 1px dashed #005494;
        margin-top:2px;
        border-left: 0;
        height: 100%;
        
    }
    .p-grid{
        margin-right: 0;
        margin-left: 0;
    }

    .loginformgvesqueci a{
        color: white;
    }
    .bg1 {
        background-color: #007ad9;
    }
    .bg2 {
        background-color: green;
    }

    .wrap-pic1 {
        width: 70%; 
    }
    .bg-img1{
        background-image: url('../../assets/certidoes.png');
    }
    .texto-sistema{
        font-size: 40px;
        color: #005494;
        font-weight: bold;
        padding:0;
        margin:0;
        
    }
    .icon-login{     
        width: 50%;
        margin-top: 4vw;
        margin-bottom: 4vw;
        margin-left: -2.2vw;
    }
    .img-top-phone{
        width: 90%;
        margin-top: 12vw;
        margin-left: -6vw;

    }
    .img-footer-phone{
        width: 12vw;
        margin-left: 8vw;
        margin-top: 4vw;
    }
    .m1-txt1{
        font-size: 15px;
    }
    .s2-txt4{
        text-transform:none;
        font-family: "Open Sans", "Helvetica Neue", sans-serif;
        font-size: 15px;
    }
    .bor2{
        text-align: center;
        cursor: pointer;
    }

    .confirmation-content {
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .view-phone{
        display: none;
    }
 

    @media screen and (max-width: 40em) {

       
        
        .img-atencao{
            width: 100% !important;
        }
       .display{
           display: none !important;
       }
       .reponsive-celular{
           padding-right: 26px !important; 
           padding-left: 18px !important;
       }
       .wrap-pic1{
           width: 100%;
       }       
       .view-phone{
           display: block;
       }
        .logingridcontrol1{
            display: none;
        }
        .texto-sistema{
            margin-top: 12vw;
        }
        .img-footer-phone{
            width: 37vw;
            margin-left: 25vw;
            margin-top: 25vw;
        }
    }
    div.p-dropdown{ 
        padding: 0 22px 0 22px;
        width: 100%;
        border: 2px solid #e6e6e6;
        font-family: "Open Sans", "Helvetica Neue", sans-serif;
        font-size: 15px;
        line-height: 2.5;
        width: 100%;
    }
</style>